import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import NormalizedWidgetForm from "components/NormalizedWidgetForm";

export default function ChartNormalizedTagDialog(props) {
  const { tagsConfig, handleClose, isEdit, createBaseline, setCreateBaseline, baselinesList, setbaselinesList, isChartDisplayed, isNormChartCopy } = props;

  const state = useSelector(state => state);
  const NormalizationFilters = state.chartData.NormalizationFilters;

  const [normalizationData, setNormalizationData] = useState(null);

  useEffect(() => {
    const normalizedTagsData = {
      isChartView: true,
      NormalizationFilters,
      tagsConfig,
      isEdit
    };
    setNormalizationData(normalizedTagsData);
  }, []);

  const getChangedValues = (original, updated) => {
    const updatedFilters = {};
    for (const key in original) {
      if (original[key] !== updated[key]) {
        updatedFilters[key] = updated[key];
      }
    }
    return updatedFilters;
  };

  const onNormalizedTagSubmit = async data => {
    let { Tag1, ...filtersPayload } = data;
    if (!Tag1) {
      filtersPayload = getChangedValues(NormalizationFilters, filtersPayload);
    }
    handleClose(filtersPayload, Tag1);
  };

  const onCloseNormalizedForm = data => {
    if (data) {
      onNormalizedTagSubmit(data);
    }
    handleClose(null);
  };

  return (
    <>
      {normalizationData && (
        <NormalizedWidgetForm
          data={normalizationData}
          onClose={onCloseNormalizedForm}
          createBaseline={createBaseline}
          setCreateBaseline={setCreateBaseline}
          baselinesList={baselinesList}
          setbaselinesList={setbaselinesList}
          isChartDisplayed={isChartDisplayed}
          isNormChart={isNormChartCopy}
        />
      )}
    </>
  );
}
